/**
 * O fornecedor tarifou o ida e volta só de UM lado do par (409 `leg_unavailable`
 * do BFF, #6000): a outra perna tem tarifa, esta não. Não é o handle morto do
 * `FlightOfferStaleError` — refazer a busca devolve o mesmo par sem tarifa —, então
 * o caminho é trocar o voo da perna. Compartilhado entre o data layer do web-chat
 * (que o lança) e o genui-kit (que o discrimina), pelo mesmo motivo do
 * `FlightOfferStaleError`: UMA classe, senão o `instanceof` entre os pacotes mente.
 */
export class FlightTariffLegUnavailableError extends Error {
  constructor(readonly leg: 'outbound' | 'return') {
    super(`flight tariff has no fare for the ${leg} leg (409 leg_unavailable)`);
    this.name = 'FlightTariffLegUnavailableError';
  }
}
